import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../components/header_ouvid';
import Head from '../../components/head';
import Footer from '../../components/footer';
import EstOuvid from '../../components/ouvidoria/estatisticas';

function OuvidoriaScreen() {
    return (
        <Fragment>
            <Head titulo="Estatísticas - Ouvidoria Municipal" />
            <Header />
            <Container>
               <EstOuvid /><br/><br/>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default OuvidoriaScreen;